module.exports = __webpack_public_path__ + "static/media/viva_garden_01_C.022fb159.png";